import React, { useEffect, useRef, useState } from "react";
import Login from "./components/Login";
import { connect } from "../../base/redux";

import { translate } from '../../base/i18n';

import { useDispatch } from "react-redux";


const WelcomeDashboard = (props) => {

    const dispatch = useDispatch();

    return <>

        <Login />
    </>

}

const mapStateToProps = (state) => {
    return {
   

    }
}

export default translate(connect(mapStateToProps)(WelcomeDashboard));